import { STATUS_ENVIO, STATUS_VENDA } from '../../../constants'
import { DateTime } from 'luxon'

const TITULOS_POR_MICRO_STATUS = {
  'Aguardando tratativa': 'Aguardando tratativa',
  'CARGA ROUBADA (53)': 'Carga roubada',
  'CARGA ROUBADA (55)': 'Carga roubada',
  'CHEGADA EM UNIDADE (09)': 'Chegada em unidade',
  'CHEGADA EM UNIDADE (11)': 'Chegada em unidade',
  'CHEGADA NA UNIDADE': 'Chegada na unidade',
  'CLIENTE ALEGA FALTA DE MERCADORIA (20)': 'Cliente alega falta de mercadoria',
  'CLIENTE ALEGA FALTA DE MERCADORIA (54)': 'Cliente alega falta de mercadoria',
  'CLIENTE ALEGA MERCAD DESACORDO C/ PEDIDO (37)': 'Cliente alega mercadoria em desacordo com pedido',
  'Carga Recebida Em Voo Fora Da Roterização': 'Carga recebida em voo fora da roterização',
  'Carteiro não atendido - Entrega não realizada': 'Carteiro não atendido - Entrega não realizada',
  'Chegada do voo': 'Chegada do voo',
  'Chegou na Unidade Azul Cargo Express': 'Chegou na Unidade Azul Cargo Express',
  'Cliente desconhecido no local - Entrega não realizada': 'Cliente desconhecido no local - Entrega não realizada',
  'Cliente mudou-se - Entrega não realizada': 'Cliente mudou-se - Entrega não realizada',
  'Cliente no destino mudou de endereço': 'Cliente no destino mudou de endereço',
  'Cliente recusou-se a receber o objeto - Entrega não realizada': 'Cliente recusou-se a receber o objeto - Entrega não realizada',
  'DESTINATARIO DESCONHECIDO (23)': 'Destinatário desconhecido',
  'DESTINATARIO IRAH RETIRAR A MERCADORIA (22)': 'Destinatário realizará retirada da mercadoria',
  'DESTINATARIO RETIRA (22)': 'Destinatário realizará retirada da mercadoria',
  'Dados insulficientes para realizar a entrega': 'Dados insuficientes para realizar a entrega',
  'Deixou a unidade Azul Cargo Express': 'Deixou a unidade Azul Cargo Express',
  'Destinatario Desconhecido No Local': 'Destinatario desconhecido no Local',
  'Destinatário não retirou objeto no prazo': 'Destinatário não retirou objeto no prazo',
  'Dificuldades de entrega na região': 'Dificuldades de entrega na região',
  'ENCOMENDA DIRECIONADA PARA O ENTREGADOR DA REGIÃO': 'Encomenda direcionada para o entregador da região',
  'ENDERECO CAIXA POSTAL (31)': 'Endereço caixa postal',
  'ENTREGA AGENDADA PELO CLIENTE (15)': 'Entrega agendada pelo cliente',
  'ENTREGA AGUARDANDO INSTRUCOES (16)': 'Entrega aguardando instruções',
  'ENTREGA PREJUDICADA PELO HORARIO (43)': 'Entrega prejudicada pelo horário',
  'Em contato com o cliente para maiores informações': 'Em contato com o cliente para maiores informações',
  'Em devolução': 'Em devolução',
  'Embarque no veículo para transferência ou em rota para entrega': 'Embarque no veículo para transferência ou em rota para entrega',
  'Empresa sem expediente - Entrega não realizada': 'Empresa sem expediente - Entrega não realizada',
  'Endereço do cliente no destino nao foi localizado': 'Endereço do cliente no destino nao foi localizado',
  'Endereço incorreto - Entrega não realizada': 'Endereço incorreto - Entrega não realizada',
  'Endereço não localizado': 'Endereço não localizado',
  'Funcionário no destino não autorizado a receber remessas': 'Funcionário no destino não autorizado a receber remessas',
  'LOCAL DE ENTREGA FECHADO/AUSENTE (11)': 'Local de entrega fechado/ausente',
  'LOCAL DE ENTREGA NAO LOCALIZADO (10)': 'Local de entrega não localizado',
  'LOCAL DE ENTREGA NAO LOCALIZADO (34)': 'Local de entrega não localizado',
  'Local de entrega fechado': 'Local de entrega fechado',
  'Loja Fechada': 'Loja fechada',
  'MERCAD EM DEVOLUCAO EM OUTRA OPERACAO (80)': 'Em devolução',
  'MERCADORIA RECEBIDA PARA TRANSPORTE (04)': 'Mercadoria recebida para transporte',
  'NOTA FISCAL RETIDA PELA FISCALIZACAO': 'Nota fiscal retida pela fiscalização',
  'Nota fiscal da remessa retida pela fiscalização': 'Nota fiscal da remessa retida pela fiscalização',
  'Objeto ainda não chegou à unidade': 'Objeto ainda não chegou à unidade',
  'Objeto entregue ao remetente': 'Entregue',
  'Ordem de redespacho criada': 'Ordem de redespacho criada',
  'PARADO NA FISCALIZACAO': 'Parado na fiscalização',
  'Paralisação por causa do Coronavírus': 'Paralisação por causa do Coronavírus',
  'Postado': 'Postado',
  'RECEBEDOR RECUSA/NAO PODE RECEBER MERCADORIA (38)': 'Recebedor recusa/não pode receber mercadoria',
  'RESTRICAO COVID-19': 'Restrição COVID-19',
  'Recebido na filial da transportadora': 'Recebido na filial da transportadora',
  'Recebido no centro de distribuição da transportadora': 'Recebido no centro de distribuição da transportadora',
  'Recusado na agência': 'Recusado na agência',
  'Recusado no redespacho': 'Recusado pelo destinatário',
  'Redespachado': 'Redespachado',
  'Remessa devolvida ao cliente de origem': 'Remessa devolvida ao cliente de origem',
  'Remessa entregue': 'Entregue',
  'Responsável de recebimento ausente': 'Responsável de recebimento ausente',
  'Retirar nos Correios': 'Retirar nos Correios',
  'SAIDA DE UNIDADE (05)': 'Saída de unidade',
  'SAIDA PARA ENTREGA (15)': 'Saída para entrega',
  'Saída do voo': 'Saída do voo',
  'TRAFEGO INTERROMPIDO': 'Trafego interrompido',
  'Transferência finalizada': 'Transferência finalizada',
  'Transferência iniciada': 'Transferência iniciada',
  'VIA INTERDITADA (12)': 'Via interditada',
}

const TITULO_ESPERA = 'Pedido realizado'
const TITULO_COBRADO = 'Pagamento efetuado'
const TITULO_FATURADO = 'A nota fiscal do seu envio foi gerada'
const TITULO_EM_PROCESSAMENTO = 'Sua caixinha está sendo montada'
const TITULO_DESPACHADO = 'Despachado'
const TITULO_EM_TRANSITO = 'Em trânsito'
const TITULO_SAIU_PRA_ENTREGA = 'Saiu para a entrega'
const TITULO_ENTREGUE = 'Entregue'
const TITULO_CANCELADO = 'Cancelado'
const TITULO_EM_DEVOLUCAO = 'Em devolução'
const TITULO_DEVOLVIDO = 'Devolvido'
const TITULO_EXTRAVIADO = 'Extraviado'
const TITULO_FALHA_ENTREGA = 'Falha na entrega'

const TITULOS_POR_STATUS = {
  [ STATUS_VENDA.espera ]: TITULO_ESPERA,
  [ STATUS_VENDA.cobrado ]: TITULO_COBRADO,
  [ STATUS_ENVIO.faturado ]: TITULO_FATURADO,
  [ STATUS_ENVIO.emProcessamento ]: TITULO_EM_PROCESSAMENTO,
  [ STATUS_ENVIO.despachado ]: TITULO_DESPACHADO,
  [ STATUS_ENVIO.emTransito ]: TITULO_EM_TRANSITO,
  [ STATUS_ENVIO.saiuPraEntrega ]: TITULO_SAIU_PRA_ENTREGA,
  [ STATUS_ENVIO.entregue ]: TITULO_ENTREGUE,
  [ STATUS_ENVIO.cancelado ]: TITULO_CANCELADO,
  [ STATUS_ENVIO.emDevolucao ]: TITULO_EM_DEVOLUCAO,
  [ STATUS_ENVIO.devolvido ]: TITULO_DEVOLVIDO,
  [ STATUS_ENVIO.extraviado ]: TITULO_EXTRAVIADO,
  [ STATUS_ENVIO.falhaEntrega ]: TITULO_FALHA_ENTREGA,
}

class LogRastreamento {
  static removeRepetidos( logs ) {
    return logs.filter( ( logLista, indiceLogLista ) => {
      const indicePrimeiroLog = logs
        .findIndex( primeiroLog => logLista.temMesmoTituloEDescricaoQue( primeiroLog ) )

      return indiceLogLista === indicePrimeiroLog
    } )
  }

  static constroiListaExibicao( logs ) {
    // Para cada mudança de status, queremos que exista um primeiro log "introdutório",
    // que tem título e descrição (se existe um definido pra esse status).
    // Por exemplo, se existe um log da RASKON que marca a mudança para "Em trânsito",
    // e cujo microstatus esteja mapeado para um título, queremos que, antes
    // desse log, seja exibido um com o título e descrição que criamos pro
    // status de "Em trânsito".

    const listaExibicao = [ ...logs ]

    for ( const status of Object.keys( TITULOS_POR_STATUS ) ) {
      const indiceStatus = listaExibicao.findIndex( log => log.status === status )
      if ( indiceStatus >= 0 ) {
        const log = listaExibicao[ indiceStatus ]
        const logSemMicro = new LogRastreamento( { status, 'timestamp': log.timestamp } )
        listaExibicao.splice( indiceStatus, 0, logSemMicro )
      }
    }

    return LogRastreamento.removeRepetidos( listaExibicao )
  }

  static getTitulo( { status, microStatus } ) {
    const tituloMicroStatus = TITULOS_POR_MICRO_STATUS[ microStatus ]
    const tituloStatus = TITULOS_POR_STATUS[ status ]

    return tituloMicroStatus || tituloStatus || ''
  }

  static getDescricao( { titulo } ) {
    const descricoesPorTitulo = {
      [ TITULO_CANCELADO ]: 'Seu pedido foi cancelado. Por favor, entre em contato.',
      [ TITULO_COBRADO ]: 'Sua experiência literária já começou! Recebemos o pagamento do seu kit e em breve iniciaremos a montagem da sua caixinha.',
      [ TITULO_DESPACHADO ]: 'Sua caixinha está cada vez mais perto de você! Seu kit já foi retirado pela transportadora e em breve estará a caminho.',
      [ TITULO_DEVOLVIDO ]: 'Sua caixinha foi devolvida. Por favor, entre em contato.',
      [ TITULO_EM_DEVOLUCAO ]: 'Sua caixinha entrou em processo de devolução. Por favor, entre em contato.',
      [ TITULO_EM_TRANSITO ]: 'Já pode ir preparando o seu cantinho de leitura, pois o seu kit já está a caminho!',
      [ TITULO_ENTREGUE ]: 'Agora é só curtir a leitura! Não se esqueça de liberar o livro no aplicativo para discutir a obra com outros associados.',
      [ TITULO_ESPERA ]: 'Seu pedido foi feito! Estamos apenas aguardando a confirmação do pagamento para montar a caixinha.',
      [ TITULO_EXTRAVIADO ]: 'Sua caixinha foi extraviada. Por favor, entre em contato.',
      [ TITULO_FALHA_ENTREGA ]: 'Ocorreu uma falha na entrega da sua caixinha. Por favor, entre em contato.',
      [ TITULO_SAIU_PRA_ENTREGA ]: 'Prepare-se, sua caixinha está quase chegando! Em breve, a transportadora lhe entregará uma nova experiência literária.',
    }

    return descricoesPorTitulo[ titulo ] || ''
  }

  static formatarTimestamp( timestamp ) {
    const data = DateTime.fromISO( timestamp ).setZone( 'UTC-3' )

    return data.invalid ? '' : data.toFormat( 'dd/MM/yyyy | HH:mm' )
  }

  constructor( { status, microStatus, timestamp } ) {
    this.status = status
    this.microStatus = microStatus
    this.timestamp = timestamp

    const titulo = LogRastreamento.getTitulo( { microStatus, status } )
    this.titulo = titulo

    this.descricao = LogRastreamento.getDescricao( { titulo } )

    this.textoData = LogRastreamento.formatarTimestamp( timestamp )
  }

  isErro() {
    const statusErro = [
      STATUS_ENVIO.cancelado,
      STATUS_ENVIO.emDevolucao,
      STATUS_ENVIO.devolvido,
      STATUS_ENVIO.extraviado,
      STATUS_ENVIO.falhaEntrega,
    ]

    return statusErro.includes( this.status )
  }

  temMesmoTituloEDescricaoQue( outroLog ) {
    return this.titulo === outroLog.titulo && this.descricao === outroLog.descricao
  }
}

export default LogRastreamento
